// extracted by mini-css-extract-plugin
module.exports = {"list":"SharePanel-list-3ed2","item":"SharePanel-item-3ed2","button":"SharePanel-button-3ed2","copy":"SharePanel-copy-3ed2"};